export default __webpack_public_path__ + "img/img_ed-d620772ffa5c40a559bcb4d081b2680d.jpg";